import React from 'react';
import MainLayout from '../components/MainLayout';
import { Link } from 'react-router-dom';
import whoweare from '../assets/images/img/who-we-are.jpg';
import Accordion from 'react-bootstrap/Accordion';

export default function GDSPATools() {
  return (

    <>
    <MainLayout>

    <div className='breadcrumb_area'>
    <div className='photo'>
    <img src={whoweare} alt=''/>
      <div className='wrapper'> 
          <div className='container'>
          <div className='row'>
          <div className='col-12'>
          <h1 className='breadcrumb_title'>GDS Process Automation Tools</h1>
          <ul className="breadcrumb_list">
          <li className="breadcrumb_item"><Link to='/'>Home</Link></li>
          <li className="breadcrumb_item">GDS Process Automation Tools</li>                 
          </ul>
          </div>
          </div>
          </div>  
      </div>
    </div>
    </div>

    <div className='inner_page_content digital_marketing travel_tourism_b2b'> 
      <div className='container'>

          <div className='row'>
        
          <div className='col-12'>
              <h2>GDS Process Automation Tools </h2>
              <p>We offer advanced Global Distribution System (GDS) Process Automation Tools designed to streamline and optimize travel booking and management workflows for travel agencies, tour operators, and businesses. Our automation tools integrate with major GDS platforms like Amadeus, Sabre, and Galileo, providing seamless access to flight, hotel, car rental, and other travel services, all while reducing manual effort and increasing efficiency.</p>
        
              <p>Our GDS Process Automation Tools are designed to help travel agencies and businesses stay ahead of the competition by improving workflow efficiency, reducing costs, and enhancing the customer experience. Let us help you streamline your operations and unlock new levels of productivity.</p>
        
          </div>

        <div className='col-12'>
          <h4>GDS Process Automation Products</h4>
          <Accordion>

<Accordion.Item eventKey="0">
  <Accordion.Header>Itinerary Plus</Accordion.Header>
  <Accordion.Body>
 <h6>Customized Templates: </h6>
 <p>Choose from tens of existing Templates for Itinerary and Tickets generation. Simple and easy way to request new Templates free of cost.</p>

<h6 className='mt-3'>Provisioning Portal</h6>
<p>Manage your customers, provision access, manage reference data and use reporting dashboard with tons of options.</p>

<h6 className='mt-3'>Export options</h6>
<p>Various generate and export options i.e. Pdf, Word, Html and Print.</p>

<h6 className='mt-3'>Cryptic based Itinerary Generation</h6>
<p>Additional capability to generate and send Itineraries without opening any GUI. Simply use new Cryptic entries with various modifiers.</p>


  </Accordion.Body>
</Accordion.Item>

<Accordion.Item eventKey="1">
  <Accordion.Header>Robots</Accordion.Header>
  <Accordion.Body>
  <h6>HX Preventer  </h6>
  <p>Proactive way, A robot that keeps track of possible future HX. Produce report and notify users to handle the segment or cancel before HX happens.</p>

  <h6 className='mt-3'>Ticketing Robot  </h6>
  <p>Automatic ticketing based on defined rules that include QC of PNR elements, linked PCCs and exclusion rules.</p>

  <h6 className='mt-3'>GDS Sales Report  </h6>
  <p>Generate automatic sales report based on markets / zones / customers and deliver in Pivot format / excel sheets to specified email addresses.</p>



  </Accordion.Body>
</Accordion.Item>

<Accordion.Item eventKey="2">
  <Accordion.Header>Quality Check</Accordion.Header>
  <Accordion.Body>

  <h6>QC Studio</h6>
  <p>Define QC rules based on Agency / Corporate. Mandate the use of specific elements before finishing PNR / ticketing. Easy admin interface to create rules.</p>

  <h6 className='mt-3'>Credit Check  </h6>
  <p>Corporates and Sub agency credit limits management made easy and directly integrated with Smartpoint. Seamless integration with backoffice for fetch Corporates and Sub agency current limits. Approve exceptions using smart devices.</p>

  <h6 className='mt-3'>Private Fare Checker  </h6>
  <p>Special kind of QC, an application that checks private fare which could be potentially used and provides prompts on Smartpoint. Ability to use private fares if missed out.</p>

  <h6 className='mt-3'>Form+  </h6>
  <p>Build easy forms and encapsulate pile of required cryptic entries in the background. An easy admin interface to create forms on various triggers during PNR generation process.</p>


  </Accordion.Body>
</Accordion.Item>



</Accordion>

        </div>


        <div className='col-12 mt-5'>
          <h4 className='mb-3'>Product & Services</h4>
          <ul>
  
  <li>Itinerary management</li>
  <li> Document generation</li>
  <li> Workflow solutions</li>
  <li> Credit checks</li>
  <li>Quality checks</li>
  <li> Scripting</li>
  <li>Reporting</li>
  <li>Mid/back office integration</li>
  <li> Bespoke solutions</li>
  <li> API Development</li>
</ul>
        </div>
   


          </div>

      </div>
    </div>

    </MainLayout>
    </>

  )
}
